var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", [
    _c(
      "div",
      { staticClass: "layout" },
      [
        _c("div", { staticClass: "layout__header" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "layout__controls" }, [
            _c("div", { staticClass: "form-inline" }, [
              _c(
                "button",
                {
                  staticClass: "btn-secondary",
                  attrs: { type: "button" },
                  on: { click: _vm.abrirComisiones }
                },
                [
                  _c("i", { staticClass: "fa fa-list-alt" }),
                  _c("span", [_vm._v("Comisiones")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-primary",
                  attrs: { type: "button" },
                  on: { click: _vm.abrirPreferencias }
                },
                [
                  _c("i", { staticClass: "fa fa-cog" }),
                  _c("span", [_vm._v("Preferencias")])
                ]
              ),
              _vm._v(" "),
              _vm.superadmin === "S"
                ? _c(
                    "button",
                    {
                      staticClass: "btn-bus200 btn--bigger",
                      attrs: { type: "button" },
                      on: { click: _vm.abrirBillRobot }
                    },
                    [_c("span", [_vm._v("My BillBot")])]
                  )
                : _vm._e()
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__main" }, [
          _c("div", { staticClass: "layout__main-form" }, [
            _c("div", { staticClass: "row mb-0" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c("div", { staticClass: "card" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "card__content" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    placeholder: "Nombre comercial o abreviado",
                                    type: "text",
                                    id: "nombre_abreviado"
                                  },
                                  model: {
                                    value: _vm.form.nombre_comercial,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "nombre_comercial",
                                        $$v
                                      )
                                    },
                                    expression: "form.nombre_comercial"
                                  }
                                },
                                [
                                  _c("span", [_vm._v("Nombre comercial *")]),
                                  _vm._v(" "),
                                  _vm.errores.nombre_comercial
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores.nombre_comercial[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    placeholder:
                                      "Razón social de la empresa o persona",
                                    type: "text",
                                    id: "razon_social"
                                  },
                                  model: {
                                    value: _vm.form.razon_social,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "razon_social", $$v)
                                    },
                                    expression: "form.razon_social"
                                  }
                                },
                                [
                                  _c("span", [_vm._v("Razón social *")]),
                                  _vm._v(" "),
                                  _vm.errores.razon_social
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores.razon_social[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    placeholder: "Número de RUC",
                                    type: "text",
                                    id: "ruc_empresa"
                                  },
                                  model: {
                                    value: _vm.form.ruc_contribuyente,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "ruc_contribuyente",
                                        $$v
                                      )
                                    },
                                    expression: "form.ruc_contribuyente"
                                  }
                                },
                                [
                                  _c("span", [_vm._v("RUC *")]),
                                  _vm._v(" "),
                                  _vm.errores.ruc_contribuyente
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores.ruc_contribuyente[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    placeholder: "Página web",
                                    type: "text",
                                    id: "paginaWeb"
                                  },
                                  model: {
                                    value: _vm.form.sitio_web,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "sitio_web", $$v)
                                    },
                                    expression: "form.sitio_web"
                                  }
                                },
                                [
                                  _c("span", [_vm._v("Página web")]),
                                  _vm._v(" "),
                                  _vm.errores.pagina_web
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.errores.pagina_web[0])
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    vMoney: "",
                                    format: _vm.porcentaje,
                                    placeholder: "% ##.##",
                                    type: "text",
                                    id: "retencionProductos"
                                  },
                                  model: {
                                    value: _vm.form.retencion_productos,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "retencion_productos",
                                        $$v
                                      )
                                    },
                                    expression: "form.retencion_productos"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v("% Retención de productos")
                                  ]),
                                  _vm._v(" "),
                                  _vm.errores.retencion_productos
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores
                                                  .retencion_productos[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    vMoney: "",
                                    format: _vm.porcentaje,
                                    placeholder: "% ##.##",
                                    type: "text",
                                    id: "retencionServicios"
                                  },
                                  model: {
                                    value: _vm.form.retencion_servicios,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "retencion_servicios",
                                        $$v
                                      )
                                    },
                                    expression: "form.retencion_servicios"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v("% Retención de servicios")
                                  ]),
                                  _vm._v(" "),
                                  _vm.errores.retencion_servicios
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores
                                                  .retencion_servicios[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    vMoney: "",
                                    format: _vm.money,
                                    placeholder: "$ ##.##",
                                    type: "text",
                                    id: "comision_base"
                                  },
                                  model: {
                                    value: _vm.form.comision_base,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "comision_base", $$v)
                                    },
                                    expression: "form.comision_base"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v("Monto base de comisiones")
                                  ]),
                                  _vm._v(" "),
                                  _vm.errores.comision_base
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores.comision_base[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    vMoney: "",
                                    format: _vm.porcentaje,
                                    placeholder: "% ##.##",
                                    type: "text",
                                    id: "porcentaje_comision"
                                  },
                                  model: {
                                    value: _vm.form.porcentaje_comision,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "porcentaje_comision",
                                        $$v
                                      )
                                    },
                                    expression: "form.porcentaje_comision"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v("% Porcentaje de comisión")
                                  ]),
                                  _vm._v(" "),
                                  _vm.errores.porcentaje_comision
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores
                                                  .porcentaje_comision[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    placeholder: "Correo electrónico",
                                    type: "text",
                                    id: "email"
                                  },
                                  model: {
                                    value: _vm.form.email_empresa,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "email_empresa", $$v)
                                    },
                                    expression: "form.email_empresa"
                                  }
                                },
                                [
                                  _c("span", [_vm._v("E-mail *")]),
                                  _vm._v(" "),
                                  _vm.errores.email_empresa
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores.email_empresa[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    placeholder:
                                      "Dirección de la empresa o persona",
                                    type: "text",
                                    id: "direccion"
                                  },
                                  model: {
                                    value: _vm.form.direccion_empresa,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "direccion_empresa",
                                        $$v
                                      )
                                    },
                                    expression: "form.direccion_empresa"
                                  }
                                },
                                [
                                  _c("span", [_vm._v("Dirección *")]),
                                  _vm._v(" "),
                                  _vm.errores.direccion_empresa
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores.direccion_empresa[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    vMoney: "",
                                    format: _vm.int,
                                    type: "text",
                                    id: "telefono_1",
                                    placeholder: "Teléfono principal"
                                  },
                                  model: {
                                    value: _vm.form.telefono,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "telefono", $$v)
                                    },
                                    expression: "form.telefono"
                                  }
                                },
                                [
                                  _c("span", [_vm._v("Teléfono 1")]),
                                  _vm._v(" "),
                                  _vm.errores.telefono
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.errores.telefono[0])
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    vMoney: "",
                                    format: _vm.int,
                                    type: "text",
                                    id: "telefono_2",
                                    placeholder: "Teléfono secundario"
                                  },
                                  model: {
                                    value: _vm.form.telefono2,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "telefono2", $$v)
                                    },
                                    expression: "form.telefono2"
                                  }
                                },
                                [
                                  _c("span", [_vm._v("Teléfono 2")]),
                                  _vm._v(" "),
                                  _vm.errores.telefono2
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.errores.telefono2[0])
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    type: "text",
                                    id: "fax",
                                    placeholder: "Fax de la empresa o persona"
                                  },
                                  model: {
                                    value: _vm.form.fax,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "fax", $$v)
                                    },
                                    expression: "form.fax"
                                  }
                                },
                                [
                                  _c("span", [_vm._v("FAX")]),
                                  _vm._v(" "),
                                  _vm.errores.fax
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.errores.fax[0]))
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c("div", { staticClass: "form-field select2" }, [
                            _c(
                              "div",
                              { staticClass: "select2-field" },
                              [
                                _c("v-select", {
                                  attrs: {
                                    options: _vm.paises,
                                    label: "nombre",
                                    id: "pais",
                                    placeholder: "Seleccione..."
                                  },
                                  model: {
                                    value: _vm.selectedPais,
                                    callback: function($$v) {
                                      _vm.selectedPais = $$v
                                    },
                                    expression: "selectedPais"
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", { attrs: { for: "pais" } }, [
                                  _vm._v("País")
                                ])
                              ],
                              1
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c("div", { staticClass: "form-field select2" }, [
                            _c(
                              "div",
                              { staticClass: "select2-field" },
                              [
                                _c("v-select", {
                                  attrs: {
                                    options: _vm.provincias,
                                    label: "nombre",
                                    id: "pais",
                                    placeholder: "Seleccione..."
                                  },
                                  model: {
                                    value: _vm.selectedProvincia,
                                    callback: function($$v) {
                                      _vm.selectedProvincia = $$v
                                    },
                                    expression: "selectedProvincia"
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", { attrs: { for: "pais" } }, [
                                  _vm._v("Provincia")
                                ])
                              ],
                              1
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c("div", { staticClass: "form-field select2" }, [
                            _c(
                              "div",
                              { staticClass: "select2-field" },
                              [
                                _c("v-select", {
                                  attrs: {
                                    options: _vm.ciudades,
                                    label: "nombre",
                                    id: "ciudad",
                                    placeholder: "Seleccione..."
                                  },
                                  model: {
                                    value: _vm.selectedCiudad,
                                    callback: function($$v) {
                                      _vm.selectedCiudad = $$v
                                    },
                                    expression: "selectedCiudad"
                                  }
                                }),
                                _vm._v(" "),
                                _c("label", { attrs: { for: "ciudad" } }, [
                                  _vm._v("Ciudad")
                                ]),
                                _vm._v(" "),
                                _vm.errores.ciudad
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(_vm._s(_vm.errores.ciudad[0]))
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c("div", { staticClass: "form-field" }, [
                            _c(
                              "label",
                              { attrs: { for: "contribuyente_especial" } },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.contribuyente_especial,
                                      expression: "form.contribuyente_especial"
                                    }
                                  ],
                                  staticClass: "is-filled",
                                  attrs: {
                                    type: "checkbox",
                                    id: "contribuyente_especial"
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.form.contribuyente_especial
                                    )
                                      ? _vm._i(
                                          _vm.form.contribuyente_especial,
                                          null
                                        ) > -1
                                      : _vm.form.contribuyente_especial
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.form.contribuyente_especial,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.form,
                                              "contribuyente_especial",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.form,
                                              "contribuyente_especial",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.form,
                                          "contribuyente_especial",
                                          $$c
                                        )
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Contribuyente especial")])
                              ]
                            ),
                            _vm._v(" "),
                            _vm.errores.contribuyente_especial
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errores.contribuyente_especial[0]
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.contribuyente_especial,
                              expression: "form.contribuyente_especial"
                            }
                          ],
                          staticClass: "col-xs-12 col-md-6 col-lg-4"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    id: "resContribuyenteEspecial",
                                    placeholder: "N° de contribuyente"
                                  },
                                  model: {
                                    value: _vm.form.numero_cont_espec,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "numero_cont_espec",
                                        $$v
                                      )
                                    },
                                    expression: "form.numero_cont_espec"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v("Res. Contribuyente Especial")
                                  ]),
                                  _vm._v(" "),
                                  _vm.errores.numero_cont_espec
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores.numero_cont_espec[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    id: "detalle_adicional_venta",
                                    placeholder: "Escriba un detalle..."
                                  },
                                  model: {
                                    value: _vm.form.detalle_adicional_venta,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "detalle_adicional_venta",
                                        $$v
                                      )
                                    },
                                    expression: "form.detalle_adicional_venta"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v("Detalle adicional de venta")
                                  ]),
                                  _vm._v(" "),
                                  _vm.errores.detalle_adicional_venta
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores
                                                  .detalle_adicional_venta[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    id: "monto_maximo_cf",
                                    placeholder: "Escriba un monto..."
                                  },
                                  model: {
                                    value: _vm.form.monto_maximo_cf,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "monto_maximo_cf", $$v)
                                    },
                                    expression: "form.monto_maximo_cf"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v("Monto máximo de consumidor final")
                                  ]),
                                  _vm._v(" "),
                                  _vm.errores.monto_maximo_cf
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "helper-text text-danger",
                                          attrs: { slot: "helper" },
                                          slot: "helper"
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errores.monto_maximo_cf[0]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c("div", { staticClass: "form-field" }, [
                            _c("label", { attrs: { for: "exportador" } }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.exportador,
                                    expression: "form.exportador"
                                  }
                                ],
                                staticClass: "is-filled",
                                attrs: { type: "checkbox", id: "exportador" },
                                domProps: {
                                  checked: Array.isArray(_vm.form.exportador)
                                    ? _vm._i(_vm.form.exportador, null) > -1
                                    : _vm.form.exportador
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.form.exportador,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.form,
                                            "exportador",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.form,
                                            "exportador",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.form, "exportador", $$c)
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("Exportador")])
                            ]),
                            _vm._v(" "),
                            _vm.errores.exportador
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.errores.exportador[0]))
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c("div", { staticClass: "form-field" }, [
                            _c(
                              "label",
                              { attrs: { for: "obligadoContabilidad" } },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.obligado_contabilidad,
                                      expression: "form.obligado_contabilidad"
                                    }
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    id: "obligadoContabilidad"
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.form.obligado_contabilidad
                                    )
                                      ? _vm._i(
                                          _vm.form.obligado_contabilidad,
                                          null
                                        ) > -1
                                      : _vm.form.obligado_contabilidad
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.form.obligado_contabilidad,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.form,
                                              "obligado_contabilidad",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.form,
                                              "obligado_contabilidad",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.form,
                                          "obligado_contabilidad",
                                          $$c
                                        )
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v("Obligado a llevar contabilidad")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm.errores.obligado_contabilidad
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errores.obligado_contabilidad[0]
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-md-6 col-lg-4 d-flex ai-center"
                        },
                        [
                          _c("div", { staticClass: "form-inline" }, [
                            _c("div", { staticClass: "form-field" }, [
                              _c(
                                "label",
                                { attrs: { for: "esMicroempresa" } },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.es_microempresa,
                                        expression: "form.es_microempresa"
                                      }
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      id: "esMicroempresa"
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.form.es_microempresa
                                      )
                                        ? _vm._i(
                                            _vm.form.es_microempresa,
                                            null
                                          ) > -1
                                        : _vm.form.es_microempresa
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.form.es_microempresa,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.form,
                                                "es_microempresa",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.form,
                                                "es_microempresa",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.form,
                                            "es_microempresa",
                                            $$c
                                          )
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Es RIMPE")])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.form.es_microempresa,
                                    expression: "form.es_microempresa"
                                  }
                                ],
                                staticClass: "form-field"
                              },
                              [
                                _c(
                                  "label",
                                  { attrs: { for: "es_negocio_popular" } },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.form.es_negocio_popular,
                                          expression: "form.es_negocio_popular"
                                        }
                                      ],
                                      attrs: {
                                        type: "checkbox",
                                        id: "es_negocio_popular"
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.form.es_negocio_popular
                                        )
                                          ? _vm._i(
                                              _vm.form.es_negocio_popular,
                                              null
                                            ) > -1
                                          : _vm.form.es_negocio_popular
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a = _vm.form.es_negocio_popular,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.form,
                                                  "es_negocio_popular",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.form,
                                                  "es_negocio_popular",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.form,
                                              "es_negocio_popular",
                                              $$c
                                            )
                                          }
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("Es negocio popular")])
                                  ]
                                )
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    id: "resolucion_agente_retencion",
                                    placeholder: "###"
                                  },
                                  model: {
                                    value: _vm.form.resolucion_agente_retencion,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "resolucion_agente_retencion",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.resolucion_agente_retencion"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v("Resolución de agente de retención")
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _vm.errores.resolucion_agente_retencion
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errores
                                              .resolucion_agente_retencion[0]
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    id: "calificacion_artesanal",
                                    placeholder: "###"
                                  },
                                  model: {
                                    value: _vm.form.calificacion_artesanal,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "calificacion_artesanal",
                                        $$v
                                      )
                                    },
                                    expression: "form.calificacion_artesanal"
                                  }
                                },
                                [_c("span", [_vm._v("Calificación artesanal")])]
                              ),
                              _vm._v(" "),
                              _vm.errores.calificacion_artesanal
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errores
                                              .calificacion_artesanal[0]
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    id: "url_facebook",
                                    placeholder: "@"
                                  },
                                  model: {
                                    value: _vm.form.url_facebook,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "url_facebook", $$v)
                                    },
                                    expression: "form.url_facebook"
                                  }
                                },
                                [_c("span", [_vm._v("Facebook")])]
                              ),
                              _vm._v(" "),
                              _vm.errores.url_facebook
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.errores.url_facebook[0])
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    id: "url_instagram",
                                    placeholder: "@"
                                  },
                                  model: {
                                    value: _vm.form.url_instagram,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "url_instagram", $$v)
                                    },
                                    expression: "form.url_instagram"
                                  }
                                },
                                [_c("span", [_vm._v("Instagram")])]
                              ),
                              _vm._v(" "),
                              _vm.errores.url_instagram
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.errores.url_instagram[0])
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-field" },
                            [
                              _c(
                                "input-field",
                                {
                                  attrs: {
                                    id: "url_twitter",
                                    placeholder: "@"
                                  },
                                  model: {
                                    value: _vm.form.url_twitter,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "url_twitter", $$v)
                                    },
                                    expression: "form.url_twitter"
                                  }
                                },
                                [_c("span", [_vm._v("Twitter")])]
                              ),
                              _vm._v(" "),
                              _vm.errores.url_twitter
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.errores.url_twitter[0])
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c("div", { staticClass: "form-field" }, [
                            _c(
                              "label",
                              { attrs: { for: "calcular_totales_final" } },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.calcular_totales_final,
                                      expression: "form.calcular_totales_final"
                                    }
                                  ],
                                  staticClass: "is-filled",
                                  attrs: {
                                    type: "checkbox",
                                    id: "calcular_totales_final"
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.form.calcular_totales_final
                                    )
                                      ? _vm._i(
                                          _vm.form.calcular_totales_final,
                                          null
                                        ) > -1
                                      : _vm.form.calcular_totales_final
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.form.calcular_totales_final,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.form,
                                              "calcular_totales_final",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.form,
                                              "calcular_totales_final",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          _vm.form,
                                          "calcular_totales_final",
                                          $$c
                                        )
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "Calcular impuestos respecto a los totales\n                          finales"
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm.errores.calcular_totales_final
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errores.calcular_totales_final[0]
                                        )
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-12 col-md-8" }, [
                        _c(
                          "div",
                          { staticClass: "form-field" },
                          [
                            _c(
                              "textarea-field",
                              {
                                attrs: {
                                  id: "footer_ride",
                                  placeholder:
                                    "Escriba el pie de página del ride..."
                                },
                                model: {
                                  value: _vm.form.footer_ride,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "footer_ride", $$v)
                                  },
                                  expression: "form.footer_ride"
                                }
                              },
                              [
                                _c("span", [_vm._v("Pie de Página de RIDE")]),
                                _vm._v(" "),
                                _vm.errores.footer_ride
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(_vm.errores.footer_ride[0]) +
                                            "\n                      "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c("div", { staticClass: "form-field select2" }, [
                            _c(
                              "div",
                              { staticClass: "select2-field" },
                              [
                                _c("v-select", {
                                  attrs: {
                                    options: _vm.paises,
                                    label: "nombre",
                                    id: "pais_defecto",
                                    placeholder: "Seleccione..."
                                  },
                                  on: { input: _vm.inputPaisDefecto },
                                  model: {
                                    value: _vm.selectedPaisDefecto,
                                    callback: function($$v) {
                                      _vm.selectedPaisDefecto = $$v
                                    },
                                    expression: "selectedPaisDefecto"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "pais_defecto" } },
                                  [_vm._v("País de persona por defecto")]
                                )
                              ],
                              1
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c("div", { staticClass: "form-field select2" }, [
                            _c(
                              "div",
                              { staticClass: "select2-field" },
                              [
                                _c("v-select", {
                                  attrs: {
                                    options: _vm.provinciasDefecto,
                                    label: "nombre",
                                    id: "provincia_defecto",
                                    placeholder: "Seleccione..."
                                  },
                                  on: { input: _vm.inputProvinciaDefecto },
                                  model: {
                                    value: _vm.selectedProvinciaDefecto,
                                    callback: function($$v) {
                                      _vm.selectedProvinciaDefecto = $$v
                                    },
                                    expression: "selectedProvinciaDefecto"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "provincia_defecto" } },
                                  [_vm._v("Provincia de persona por defecto")]
                                )
                              ],
                              1
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-4" },
                        [
                          _c("div", { staticClass: "form-field select2" }, [
                            _c(
                              "div",
                              { staticClass: "select2-field" },
                              [
                                _c("v-select", {
                                  attrs: {
                                    options: _vm.ciudadesDefecto,
                                    label: "nombre",
                                    id: "ciudad_defecto",
                                    placeholder: "Seleccione..."
                                  },
                                  on: { input: _vm.inputCiudadDefecto },
                                  model: {
                                    value: _vm.selectedCiudadDefecto,
                                    callback: function($$v) {
                                      _vm.selectedCiudadDefecto = $$v
                                    },
                                    expression: "selectedCiudadDefecto"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "ciudad_defecto" } },
                                  [_vm._v("Ciudad de persona por defecto")]
                                ),
                                _vm._v(" "),
                                _vm.errores.ciudad_defecto_id
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errores.ciudad_defecto_id[0]
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-md-6 col-lg-8" },
                        [
                          _c("div", { staticClass: "form-field select2" }, [
                            _c(
                              "div",
                              { staticClass: "select2-field" },
                              [
                                _c("v-select", {
                                  attrs: {
                                    options: _vm.personasDefecto,
                                    label: "descripcion",
                                    id: "persona_defecto_id",
                                    placeholder: "Seleccione..."
                                  },
                                  on: {
                                    input: _vm.inputPersonaDefecto,
                                    search: _vm.searchPersonas
                                  },
                                  model: {
                                    value: _vm.selectedPersona,
                                    callback: function($$v) {
                                      _vm.selectedPersona = $$v
                                    },
                                    expression: "selectedPersona"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: "persona_defecto_id" } },
                                  [_vm._v("Persona por defecto")]
                                ),
                                _vm._v(" "),
                                _vm.errores.persona_defecto_id
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "helper-text text-danger",
                                        attrs: { slot: "helper" },
                                        slot: "helper"
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errores.persona_defecto_id[0]
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                        _c("div", { staticClass: "form-field" }, [
                          _c(
                            "div",
                            { staticClass: "multiselect-field" },
                            [
                              _c("multiselect", {
                                ref: "multi_cco_auth",
                                attrs: {
                                  "tag-placeholder":
                                    "Agrega uno o más correos...",
                                  placeholder: "Agrega uno o más correos...",
                                  selectedLabel: "Seleccionado",
                                  deselectLabel: "Presiona enter para eliminar",
                                  id: "correos_copia_oculta_autorizacion",
                                  label: "descripcion",
                                  "track-by": "descripcion",
                                  options:
                                    _vm.selectedCorreosCopiaOcultaAutorizacion,
                                  multiple: true,
                                  taggable: true,
                                  showNoResults: false,
                                  showNoOptions: false,
                                  hideSelected: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.inputCorreosCopiaOcultaAutorizacion()
                                  },
                                  tag: _vm.addTagCorreosCopiaOcultaAutorizacion
                                },
                                model: {
                                  value:
                                    _vm.selectedCorreosCopiaOcultaAutorizacion,
                                  callback: function($$v) {
                                    _vm.selectedCorreosCopiaOcultaAutorizacion = $$v
                                  },
                                  expression:
                                    "selectedCorreosCopiaOcultaAutorizacion"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  attrs: {
                                    for: "correos_copia_oculta_autorizacion"
                                  }
                                },
                                [
                                  _vm._v(
                                    "Correos para autorización (con copia oculta)"
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.errores.correos_copia_oculta_autorizacion
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errores
                                              .correos_copia_oculta_autorizacion[0]
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                        _c("div", { staticClass: "form-field select2" }, [
                          _c(
                            "div",
                            { staticClass: "select2-field" },
                            [
                              _c("v-select", {
                                attrs: {
                                  options: _vm.formasPago,
                                  tooltip: _vm.selectedFormaPagoDefault
                                    ? _vm.selectedFormaPagoDefault.nombre
                                    : null,
                                  label: "nombre",
                                  id: "forma_pago_id_default",
                                  placeholder: "Seleccione..."
                                },
                                on: { input: _vm.inputFormaPagoDefault },
                                model: {
                                  value: _vm.selectedFormaPagoDefault,
                                  callback: function($$v) {
                                    _vm.selectedFormaPagoDefault = $$v
                                  },
                                  expression: "selectedFormaPagoDefault"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "forma_pago_id_default" } },
                                [_vm._v("Forma de pago por defecto")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c("div", { staticClass: "card mt-3 max-content" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "card__content" }, [
                    _c("div", { staticClass: "file-logo-upload" }, [
                      _c("img", {
                        staticClass: "file-logo-upload__img",
                        attrs: { id: "logoImg", src: _vm.urlLogo, alt: "Logo" }
                      }),
                      _vm._v(" "),
                      _c(
                        "form",
                        {
                          attrs: {
                            action: _vm.url + "/parametros/imagen",
                            id: "form_imagen",
                            enctype: "multipart/form-data",
                            method: "post"
                          }
                        },
                        [
                          _c("input", {
                            attrs: { type: "hidden", name: "_token" },
                            domProps: { value: _vm.token }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            staticClass: "file-logo-upload__input",
                            attrs: { type: "file", name: "logo", id: "logo" },
                            on: { change: _vm.readUrl }
                          }),
                          _vm._v(" "),
                          _vm._m(3),
                          _vm._v(" "),
                          _vm._m(4)
                        ]
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c("div", { staticClass: "card mt-3 max-content" }, [
                  _vm._m(5),
                  _vm._v(" "),
                  _c("div", { staticClass: "card__content" }, [
                    _c("div", { staticClass: "file-logo-upload" }, [
                      _c("img", {
                        staticClass: "file-logo-upload__img",
                        attrs: { id: "logoImgQr", src: _vm.urlQr, alt: "QR" }
                      }),
                      _vm._v(" "),
                      _c(
                        "form",
                        {
                          attrs: {
                            action: _vm.url + "/parametros/qr",
                            id: "form_qr",
                            enctype: "multipart/form-data",
                            method: "post"
                          }
                        },
                        [
                          _c("input", {
                            attrs: { type: "hidden", name: "_token" },
                            domProps: { value: _vm.token }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            staticClass: "file-logo-upload__input",
                            attrs: { type: "file", name: "qr", id: "qr" },
                            on: { change: _vm.readUrlQR }
                          }),
                          _vm._v(" "),
                          _vm._m(6),
                          _vm._v(" "),
                          _vm._m(7)
                        ]
                      )
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "layout__main-buttons" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card__content" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn-success",
                    attrs: { type: "button" },
                    on: { click: _vm.guardarCambios }
                  },
                  [
                    _c("i", { staticClass: "fa fa-save" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Guardar")])
                  ]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "modal",
          {
            ref: "robot",
            attrs: {
              width: "60%",
              clickToClose: false,
              height: "auto",
              scrollable: true,
              name: "robot"
            }
          },
          [
            _c("parametros-bill-bot", {
              on: { cerrarModalBot: _vm.cerrarBillRobot }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "modal",
          {
            ref: "preferencias",
            attrs: {
              width: "85%",
              clickToClose: false,
              height: "auto",
              scrollable: true,
              name: "preferencias"
            }
          },
          [
            _c("parametros-preferencias", {
              attrs: { superadmin: _vm.superadmin },
              on: { cerrar: _vm.cerrarPreferencias }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "modal",
          {
            ref: "comisiones",
            attrs: {
              width: "70%",
              clickToClose: false,
              height: "auto",
              scrollable: true,
              name: "comisiones"
            }
          },
          [_c("comisiones")],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Parametros del sistema")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información de la empresa")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Logo de la empresa")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "file-logo-upload__label", attrs: { for: "logo" } },
      [_c("i", { staticClass: "fa fa-upload" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "file-logo-upload__button btn-secondary",
        attrs: {
          type: "button",
          onclick: "document.getElementById('form_imagen').submit()"
        }
      },
      [
        _c("i", { staticClass: "fa fa-refresh" }),
        _c("span", [_vm._v("Cambiar logo")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("QR en RIDE")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "file-logo-upload__label", attrs: { for: "qr" } },
      [_c("i", { staticClass: "fa fa-upload" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "file-logo-upload__button btn-secondary",
        attrs: {
          type: "button",
          onclick: "document.getElementById('form_qr').submit()"
        }
      },
      [
        _c("i", { staticClass: "fa fa-refresh" }),
        _c("span", [_vm._v("Cambiar QR")])
      ]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b02e624", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b02e624","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/parametrizacion/ParametrosGeneral.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6b02e624","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/parametrizacion/ParametrosGeneral.vue
// module chunks = 0